
if(document.querySelector('.custom_selector_sorting')){
  let custom_selector_sorting = document.querySelector('.custom_selector_sorting');
  let custom_sort_price = document.querySelector('.custom_sort_price');
  let custom_sort_by = document.querySelectorAll('.custom_sort_by');
  let locationHref;
  
  custom_sort_price.addEventListener('click', (e) => {
    if(custom_selector_sorting.classList.contains('open')){
      custom_selector_sorting.classList.remove('open');
    } else {
      custom_selector_sorting.classList.add('open');
    }
  });

  if(window.location.href.includes('?sort_by=price-ascending') || window.location.href.includes('&sort_by=price-ascending')){
    for(let m = 0; m < custom_sort_by.length; m++ ){
      if(custom_sort_by[m].textContent == 'Aufsteigend'){
        custom_sort_by[m].style.color = '#BEAEA1'
      }
    }
  } else if(window.location.href.includes('?sort_by=price-descending') ||  window.location.href.includes('&sort_by=price-descending')){
    for(let m = 0; m < custom_sort_by.length; m++ ){
      if(custom_sort_by[m].textContent == 'Absteigend'){
        custom_sort_by[m].style.color = '#BEAEA1'
      }
    }
  }

  function locationAssign(replace, assign){
    locationHref = window.location.href;
    if(locationHref.includes(replace)){
      locationHref = locationHref.replace(replace, '')
    } 
    if(locationHref.includes(assign)){
    } else {
      locationHref = locationHref.concat(assign);
    }
    window.location.assign(locationHref);
  }

  custom_selector_sorting.addEventListener('click', (e) => {
    if(custom_selector_sorting.classList.contains('open')){
      if(e.target.closest('.custom_sort_by')){
        if(e.target.closest('.custom_sort_by').textContent == 'Aufsteigend' ){
          if(window.location.href.includes('?filter')){
            locationAssign('&sort_by=price-descending', '&sort_by=price-ascending');
          } else {
            locationAssign('?sort_by=price-descending', '?sort_by=price-ascending');
          }
        } else {
          if(window.location.href.includes('?filter')){
            locationAssign('&sort_by=price-ascending', '&sort_by=price-descending');
          } else {
            locationAssign('?sort_by=price-ascending', '?sort_by=price-descending');
          }
        }
      }
    }
  });

}


document.addEventListener('DOMContentLoaded', function () {
  if (window.location.href.includes('/products')) {
    if (document.querySelector('.view_section')) {
      var jsON = document.querySelector('.data-json').dataset.json;
      var json = JSON.parse(jsON);
    }
    let HandleParse = window.location.href;
    let HandleParseSplit = HandleParse.split('/');
    let HandleStr = HandleParseSplit[HandleParseSplit.length - 1];
    if (HandleStr.includes('?')) {
      let HanleStrIf = HandleStr.split('?');
      HandleStr = HanleStrIf[0];
    }
    function LocationStorageGETSET() {
      let JsonParse = JSON.parse(localStorage.getItem('ViewedProduct'));
      let GetViewProductArray = JsonParse.handle;
      let GetViewProductArrayLength = GetViewProductArray.length;
      let itr = 0;
      GetViewProductArray.forEach((element, i) => {
        if (GetViewProductArray[i] == HandleStr) {
          itr = GetViewProductArray.length;
        }
      });
      if (itr == 0) {
        JsonParse.title.push(json.title)
        JsonParse.handle.push(json.handle)
        JsonParse.price.push(json.variants[0].price)
        JsonParse.img.push(json.featured_image)
      }
      localStorage.setItem("ViewedProduct", JSON.stringify(JsonParse));
    }
    if (localStorage.getItem('ViewedProduct')) {
      LocationStorageGETSET()
    } else {
      const forData = {
        title: [],
        handle: [],
        price: [],
        img: []
      }
      localStorage.setItem("ViewedProduct", JSON.stringify(forData));
      LocationStorageGETSET()
    }
  }
});